import { render, staticRenderFns } from "./BindBankCard.vue?vue&type=template&id=803919da&scoped=true&"
import script from "./BindBankCard.vue?vue&type=script&lang=js&"
export * from "./BindBankCard.vue?vue&type=script&lang=js&"
import style0 from "./BindBankCard.vue?vue&type=style&index=0&id=803919da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803919da",
  null
  
)

export default component.exports